<template>
  <div>
    <vl-modal
      id="cookie-consent-modal"
      :key="modalKey"
      v-model:open="cookieModalOpen"
      mod-bottom
      mod-disable-backdrop
      mod-enable-scroll
      closable
      :mod-locked="false"
      aria-describedby="vl-pt-cookie-consent__modal-title"
    >
      <dl-cookie-consent @submit="onModalClick" />
    </vl-modal>
  </div>
</template>

<script lang="ts" src="./dl-cookie-modal.ts"></script>

<style lang="scss" scoped>
@use './dl-cookie-modal.scss';
</style>
